import React from "react"
import { graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from "@mdx-js/react"

import Layout from "../components/layout"
import Post from "../components/post"
import Image from "../components/blog-post/image"
import Slider from "../components/blog-post/slider"
import Player from "../components/blog-post/player"
import Trip from "../components/blog-post/trip"
import Maps from "../components/blog-post/maps"
import ToC from "../components/blog-post/toc"
import Instagram from "../components/blog-post/instagram"
import Twitter from "../components/blog-post/twitter"
import Facebook from "../components/blog-post/facebook"
import Banner from "../components/banner"

import "../assets/css/swiper.css"

const BlogPostTemplate = ({ data: { post, relateds }, pageContext: { lang, canonicalUrl } }) => {
  const shortcodes = {
    ccimage: Image,
    ccslider: Slider,
    ccplayer: Player,
    cctrip: Trip,
    ccinstagram: Instagram,
    cctwitter: Twitter,
    ccfacebook: Facebook,
    ccmaps: Maps,
    cctoc: () => <ToC toc={post.tableOfContents} />,
  }

  return (
    <Layout>
      <Post post={post} relateds={relateds.edges.map(post => post.node)} canonicalUrl={canonicalUrl} lang={lang}>
        <MDXProvider components={shortcodes}>
          <MDXRenderer>{post.body}</MDXRenderer>
        </MDXProvider>
        <Banner />
      </Post>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!, $categoryId: String!, $lang: String!) {
    post: blogPost(slug: { eq: $slug }) {
      title
      slug
      alias
      author
      publishedAtFormatted: publishedAt(formatString: "LL", locale: $lang)
      publishedAt
      modifiedAt
      body
      tableOfContents
      category {
        categoryId
      }
      featuredImage {
        guid
        platformSlug
        type
        alt
        width
        height
        ext
      }
      launchImage {
        guid
        platformSlug
        alt
        title
        credits
        caption
        width
        height
        ext
      }
      launchVideoSrc
      abstract
      metaDescription
      mainCategories {
        slug
        name
        parentId
        subcategories {
          slug
          name
        }
      }
      categories {
        categoryId
        parentId
        slug
        name
      }
      relateds {
        title
        slug
        abstract
        featuredImage {
          guid
          platformSlug
          type
          alt
          width
          height
          ext
        }
        category {
          name
        }
      }
    }
    relateds: allBlogPost(
      filter: { slug: { ne: $slug }, categories: { elemMatch: { id: { eq: $categoryId } } } }
      limit: 3
    ) {
      edges {
        node {
          slug
          title
          abstract
          category {
            name
            categoryId
          }
          featuredImage {
            guid
            platformSlug
            type
            alt
            width
            height
            ext
          }
        }
      }
    }
  }
`
